var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSuccessIcon = function SvgSuccessIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.118 11.461-3.451-3.45.707-.708 2.744 2.744 5.842-5.842.707.707-6.55 6.55z",
    fill: "#000",
    fillRule: "evenodd"
  })));
};
export default SvgSuccessIcon;